import * as styles from "./IntroSponsorADogSearch.module.scss";

import React from "react";
import CurvedBorderCircular from "../../../components/borders/CurvedBorderCircular";
import CurvedBorderCircularDeep from "../../../components/borders/CurvedBorderCircularDeep";
import { Button } from "../../../components/common";
import { Search } from "../../../components/common/Icons";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../utils/colours";

interface IntroSponsorADogSearchProps {
	title: string;
	body: string;
	imgSrc: string;
	imgAlt: string;
}

export const IntroSponsorADogSearch: React.FC<IntroSponsorADogSearchProps> = ({
	title,
	body,
	imgSrc,
	imgAlt,
}) => {
	return (
		<>
			<div className={styles.mobile}>
				<div className={styles.herowithimagecontainerouter}>
					<div className={styles.herowithimagecontainer}>
						<ProcessedImage
							src={imgSrc}
							alt={imgAlt}
							dimensions="400x300"
							loading="eager"
						/>
						<div className={styles.bordersection}>
							<CurvedBorderCircular
								className={styles.border}
								rotation={0}
								fill={Colours.SUNSHINE_YELLOW}
							/>
						</div>
					</div>
					<div className={styles.textcontainer}>
						<h1>{title}</h1>
						<span
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{ __html: body }}
						/>
						<span className={styles.perweektext}>£1 per week</span>
						<div className={styles.buttonwrapper}>
							<Button
								variant="secondary"
								url={"/support-us/sponsor/dogs"}
								IconLeft={() => <Search fill={Colours.WHITE} />}
							>
								Choose your sponsor dog
							</Button>
						</div>
					</div>
				</div>
			</div>
			<div className={styles.desktop}>
				<div className={styles.herowithimagecontainerouter}>
					<div className={styles.herowithimagecontainerinner}>
						<div className={styles.herowithimagecontainer}>
							<ProcessedImage
								src={imgSrc}
								alt={imgAlt}
								dimensions="600x450"
								width={600}
								height={450}
								// preload
							/>
							<div className={styles.bordersection}>
								<CurvedBorderCircularDeep
									className={styles.border}
									rotation={0}
									fill={Colours.SUNSHINE_YELLOW}
								/>
							</div>
						</div>
						<div className={styles.textcontainer}>
							<h1>{title}</h1>
							<span
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{ __html: body }}
							/>
							<span className={styles.perweektext}>£1 per week</span>
							<div className={styles.buttonwrapper}>
								<Button
									variant="secondary"
									url={"/support-us/sponsor/dogs"}
									IconLeft={() => <Search fill={Colours.WHITE} />}
								>
									Choose your sponsor dog
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default IntroSponsorADogSearch;
